export function buildPagination({
  data,
  perPage = 25,
  requestedPage = null,
  totalItemsField = 'total',
  totalPagesField = 'total_pages',
  currentPageField = 'current_page',
}) {
  const totalItems  = Number(data?.[totalItemsField]) || 0
  const totalPages  = Number(data?.[totalPagesField])
    || (totalItems > 0 ? Math.max(1, Math.ceil(totalItems / perPage)) : 0)
  const currentPage = Number(data?.[currentPageField]) || requestedPage || 1

  return {
    perPage,
    currentPage,
    totalItems,
    totalPages,
    prevPage: currentPage > 1 ? currentPage - 1 : null,
    nextPage: currentPage < totalPages ? currentPage + 1 : null,
  }
}